import React, {useEffect} from 'react'
import Select from 'react-select'
import { useForm, Controller } from "react-hook-form";
import FormGroup from 'components/Form/FormGroup'
import FormImage from 'components/Form/FormImage'
import { useDispatch, useSelector } from 'react-redux';
import { updateAccountInfo } from 'store/actions/userActions'
import "./userInformation.scss";
import {useAuth} from 'util/auth'
// import { values } from 'analytics/lib/analytics.cjs';
import UserInformationForm from 'components/UserInfoForm'
import ReauthModal from "components/ReauthModal";

function UserInformationPage(props) {

    const dispatch = useDispatch()

    const auth = useAuth();
    const [reauthState, setReauthState] = React.useState({
        show: false,
    });

    const isLoading = useSelector(state => state.user.loading)
    const isSaving = useSelector(state => state.user.saving)
    const user = useSelector(state => state.user.userData)
    const error = useSelector(state => state.user.error)
    const success = useSelector(state => state.user.success)

    function updateAccount(data, newEmail) {

        if (!newEmail){
            dispatch(updateAccountInfo(data))
            return
        }

        auth.changeEmail(newEmail)
            .then(() => {
                return dispatch(updateAccountInfo(data))
            })
            .catch((err) => {
                // console.log(err)
                if (err?.message) {
                    window.alert(err.message)
                }
                
            })
    }

    const onSubmit = (data) => {
        // window.alert(JSON.stringify(data));
        console.log(data)
        console.log("auth user: ", auth.user)
        if (data.email !== user.email) {
            setReauthState({
                show: true,
                // Failed action to try again after reauth
                callback: function() {
                    updateAccount(data, data.email)
                },
            });
            // window.alert("changing email")
        } else {
            updateAccount(data, null)
            // dispatch(updateAccountInfo(data))
        }
        // dispatch(updateAccountInfo(data))
    }

    let height;
    const sendPostMessage = () => {
        let conatinerId = "fullWidthWidget"
        if (document.getElementById(conatinerId)) {
            if (height !== document.getElementById(conatinerId).offsetHeight) {
                height = document.getElementById(conatinerId).offsetHeight;
                window.parent.postMessage({
                  frameHeight: height
                }, '*');
                // console.log(height);
              }
        }
        
    }
    useEffect(() => {
        sendPostMessage()
    })

    return (<>
    <div className="container pb-5 px-0">
        {user.platformID ? (
            <div>
                {success && (
                    <div className="alert alert-success" role="alert">
                        {success}
                    </div>
                )}
                {error && (
                    <div className="alert alert-danger" role="alert">
                        {error}
                    </div>
                )}
                {reauthState.show && (
                    <ReauthModal
                    callback={reauthState.callback}
                    provider={auth.user.providerData[0]}
                    onDone={() => setReauthState({ show: false })}
                    ></ReauthModal>
                )}
                <UserInformationForm
                user={user}
                handleFormSubmission={onSubmit}
                isSaving={isSaving}
                />
            </div>
        ) : (
            <div>loading</div>
        )}

    </div>
    </>)
}

export default UserInformationPage;